const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const menu = [
  {
    text: "Quem Somos",
    to: "/quem-somos",
  },
  {
    text: "Implementos",
    to: "/implementos",
  },
  {
    text: "Serviços",
    to: "/servicos",
  },
];

export { server, menu };
